import getRandomInt from '../functions/getRandomInt';
import getRandomIntArray from '../functions/getRandomIntArray';
import uqnJoin from '../functions/uqnJoin';
export default function random(type) {
    if (typeof type === "undefined" || type == 0) {
        type = getRandomInt(1, 6);
    }
    if (type == 1) { // random cartesian
        let a = getRandomInt(0, 9);
        let b = getRandomInt(0, 9);
        if (a == 0 && b == 0) {
            b = getRandomInt(1, 9);
        }
        const sign = getRandomInt(0, 3);
        return uqnJoin([type, a, b, sign]);
    }
    else if (type == 2) {
        let r = getRandomInt(1, 9);
        let thetaString = "0.00";
        while (thetaString == "0.00") {
            thetaString = (Math.random() * 6.27).toFixed(2);
        }
        return uqnJoin([type, r, thetaString[0], thetaString[2], thetaString[3]]);
    }
    else if (type == 3 || type == 4) {
        let r = getRandomInt(1, 9);
        let n = getRandomInt(0, 23);
        while (n % 6 == 1 || n % 6 == 5 || n == 0) {
            n = getRandomInt(0, 23);
        }
        let n1 = 0, n2;
        if (n < 10) {
            n2 = n;
        }
        else {
            n1 = Math.floor(n / 10);
            n2 = n % 10;
        }
        return uqnJoin([type, r, n1, n2]);
    }
    else if (type == 5) {
        let [t1, t2, t3] = getRandomIntArray(1, 23, 3);
        let n = t1 * 24 * 24 + t2 * 24 + t3;
        let n1 = 0, n2 = 0, n3 = 0, n4 = 0, n5;
        if (n < 10) {
            n5 = n;
        }
        else if (n < 100) {
            n4 = Math.floor(n / 10);
            n5 = n % 10;
        }
        else if (n < 1000) {
            n3 = Number(n.toString()[0]);
            n4 = Number(n.toString()[1]);
            n5 = Number(n.toString()[2]);
        }
        else if (n < 10000) {
            n2 = Number(n.toString()[0]);
            n3 = Number(n.toString()[1]);
            n4 = Number(n.toString()[2]);
            n5 = Number(n.toString()[3]);
        }
        else {
            n1 = Number(n.toString()[0]);
            n2 = Number(n.toString()[1]);
            n3 = Number(n.toString()[2]);
            n4 = Number(n.toString()[3]);
            n5 = Number(n.toString()[4]);
        }
        let conj = getRandomInt(0, 9);
        let power = getRandomInt(2, 9);
        return uqnJoin([power, n1, n2, n3, n4, n5, conj]);
    }
    else if (type == 6) {
        let n = getRandomInt(0, 23);
        while (n % 6 == 0) {
            n = getRandomInt(0, 23);
        }
        let realImag = getRandomInt(0, 3);
        if (realImag == 3 && (n % 4 == 0)) {
            realImag = getRandomInt(0, 2);
        }
        if (realImag == 2 && (n % 8 == 0)) {
            realImag = getRandomInt(0, 1);
        }
        let n1 = 0, n2;
        if (n < 10) {
            n2 = n;
        }
        else {
            n1 = Math.floor(n / 10);
            n2 = n % 10;
        }
        return uqnJoin([type, n1, n2, realImag]);
    }
    else {
        throw "type out of bounds";
    }
}
